import axios from 'axios';
import { clearAuth, getToken, isTokenExpired } from './auth';

let isInitialized = false;
let isRedirecting = false;

function forceRedirectToLogin() {
  if (isRedirecting) {
    return;
  }

  isRedirecting = true;

  clearAuth();

  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
}

export function setupAxiosAuthRedirect() {
  if (isInitialized) {
    return;
  }

  isInitialized = true;

  axios.interceptors.request.use(
    (config) => {
      const url = config.url || '';
      const isLoginRequest = url.includes('/api/auth/login');

      if (!isLoginRequest) {
        const token = getToken();

        if (token && !isTokenExpired(token)) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        } else if (token && isTokenExpired(token)) {
          // Токен уже истёк.
          // Очищаем локальное хранилище, а ответ 401 обработает interceptor ниже.
          clearAuth();
        }
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || '';

      const isLoginRequest = url.includes('/api/auth/login');

      // Если любой защищённый запрос вернул 401, считаем сессию недействительной.
      // Важно: не трогаем /api/auth/login, чтобы неверный логин/пароль
      // показывал ошибку на странице входа, а не вызывал редирект.
      if (status === 401 && !isLoginRequest) {
        forceRedirectToLogin();
      }

      return Promise.reject(error);
    }
  );
}